export default __webpack_public_path__ + "static/media/img_down.53d16fa0.svg";